import { render, staticRenderFns } from "./PersonFormModal.vue?vue&type=template&id=d49e7b4e&scoped=true"
import script from "./PersonFormModal.vue?vue&type=script&lang=js"
export * from "./PersonFormModal.vue?vue&type=script&lang=js"
import style0 from "./PersonFormModal.vue?vue&type=style&index=0&id=d49e7b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49e7b4e",
  null
  
)

export default component.exports